import * as React from "react"
import { Layout } from "../components/layout"
import { heading, paragraph, container, question, answer} from "./FAQ.module.css"

export default function FAQ() {
  return (
    <Layout>
      <div className={container}>
        <div className="pb-5 border-b">
            <h1 className={heading}>Frequently Asked Questions</h1>
        </div>
        <div className=" text-center md:flex h-1/2 pt-10 md:text-left">
            <div className=" md:basis-1/5 md:pr-5">
                <p className={question}>ARE CAMERAREADY LITEBARS EASY ON THE EYES? </p>
            </div>
    <div className="text-center md:basis-4/5 md:text-left md:align-middle" >
      <div className="md:m-5">
        <p className={answer}>Yes, LiteBars emit soft warm white light at a 3000K color 
                            temperature. You can adjust the brightness, and most customers find 
                            their look enhanced even at a low setting
                            </p>
      </div>
    </div>

  </div>
  <div className="text-center md:flex h-1/2 pt-10 md:text-left ">
            <div className="md:basis-1/5 md:pr-5">
                <p className={question}>ARE LITEBARS DIMMABLE?</p>
            </div>
    <div className=" md: basis-4/5 " >
      <div className="md:m-5">
        <p className={answer}>Yes, press and hold the power button to dim. To brighten, let go, then press and hold again. You can find a video of this here.
                            </p>
      </div>
    </div>

  </div>
  <div className="text-center md:flex h-1/2 pt-10 md:text-left">
            <div className="sm:md:basis-1/5 md:pr-5">
                <p className={question}>HOW CAN I ADD MORE LITEBARS TO MY KIT? </p>
            </div>
    <div className=" md: basis-4/5 " >
      <div className="md:m-5">
        <p className={answer}>You can upgrade your kit at a discounted price here.
                            </p>
      </div>
    </div>

  </div>
  <div className="text-center md:flex h-1/2 pt-10 md:text-left ">
            <div className="md:basis-1/5 md:pr-5">
                <p className={question}>WHAT IS YOUR RETURN POLICY? </p>
            </div>
    <div className=" md: basis-4/5 " >
      <div className="md:m-5">
        <p className={answer}>Please refer to this page for how to set up your LiteBars.
                            </p>
      </div>
    </div>

  </div>
  <div className=" text-center md:flex h-1/2 pt-10 md:text-left ">
            <div className="md:basis-1/5 md:pr-5 md: py-auto">
                <p className={question}>DO YOU SHIP INTERNATIONALLY?</p>
            </div>
    <div className=" md: basis-4/5 " >
      <div className="md:m-5">
        <p className={answer}>We currently ship to the USA, Canada, Belgium, France, Germany, Switzerland, Australia, Thailand and the UK. We're expanding our shipping outreach, so let us know here if you would like us to ship to your country. If you have a different outlet type from North America, all you need is an adapter for your country.
                            </p>
      </div>
    </div>

  </div>
  <div className=" text-center md:flex h-1/2 pt-10 md:text-left ">
            <div className="md:basis-1/5 md:pr-5">
                <p className={question}>ARE LITEBARS BATTERY POWERED OR PLUG IN?</p>
            </div>
    <div className=" mb-10 md: basis-4/5 " >
      <div className="md:m-5 ">
        <p className={answer}>Our LiteBars are plug in, and ship with a splitter box so you can plug multiple LiteBars in.
                            </p>
      </div>
    </div>

  </div>

      </div>
    </Layout>
  )
}
